import Immutable from 'immutable';
import {
  FETCH_USER_SUBSCRIPTION_PLANS_SUCCESS,
  CANCEL_USER_SUBSCRIPTION_PLAN_SUCCESS,
  FETCH_OWNER_AND_ADMINS_SUCCESS,
  FETCH_PAYMENT_METHOD_SUMMARY_SUCCESS,
  FETCH_USER_SUBSCRIPTION_PLAN_DATA_SUCCESS,
  FETCH_MONTHLY_USAGE_SUMMARY,
  SET_CURRENT_SELECTED_USER_SUBSCRIPTION,
  LIST_INSTITUTIONS_UNDER_PLAN_SUCCESS,
  FETCH_PAYMENT_TRANSACTIONS_SUCCESS,
  FETCH_MONTHLY_USAGE_SUMMARY_START,
} from './actions';
import {
  WASABI_FETCH_USER_SUBSCRIPTIONS_SUCCESS,
  WASABI_UPDATE_USER_SUBSCRIPTION_PLAN_EXPIRY_SUCCESS,
  WASABI_CANCEL_USER_SUBSCRIPTION_PLAN_SUCCESS,
} from '../Wasabi/users/actions';
import { FETCH_COURSE_SUBSCRIPTION_DATA_SUCCESS } from '../Courses/actions';
import {
  WASABI_SAAS_FETCH_USER_SUBSCRIPTIONS_SUCCESS,
  WASABI_SAAS_FETCH_USER_SUBSCRIPTION_PLAN_DATA_SUCCESS,
} from '../Wasabi/saasSubscriptions/actions';

const initialState = Immutable.fromJS({
  byUser: {
    /*
    userId: {
      linkedInstitutions: {
        [key: string]: {
          'institutions': InstitutionSummary[],
          'owners': UserSummary[]
        }
      },
      currentSelectedUserSubscription: {},
      linkedCoursePaths: {
        'subscriptionId': {}
      },
      billingCycleUsages: {
        'subscriptionId': {}
      },
      monthlyUsages: {
        'subscriptionId': {}
      },
      ownerAndAdmins: {
        subscriptionId: {}
      }
      plans: {},
      hasLoaded: false,
    }
    */
  },
});

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function UserSubscriptionPlans(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_PAYMENT_TRANSACTIONS_SUCCESS: {
      let newState = state;
      const { userId, subscriptionId, payments } = action;

      newState = newState.mergeIn(
        ['byUser', userId, 'paymentTransactions', subscriptionId],
        payments
      );

      return newState;
    }
    case FETCH_MONTHLY_USAGE_SUMMARY_START: {
      const { userId } = action;

      return state.setIn(
        ['byUser', userId, 'monthlyUsages', 'isLoading'],
        true
      );
    }
    case FETCH_MONTHLY_USAGE_SUMMARY: {
      let newState = state;
      const { userId, subscriptionId, monthlyUsages } = action;

      newState = newState
        .setIn(
          ['byUser', userId, 'monthlyUsages', subscriptionId],
          monthlyUsages
        )
        .setIn(['byUser', userId, 'monthlyUsages', 'isLoading'], false);

      return newState;
    }
    case SET_CURRENT_SELECTED_USER_SUBSCRIPTION: {
      const { userId, userSubscriptionPlan } = action;
      let newState = state;

      newState = newState.setIn(
        ['byUser', userId, 'currentSelectedUserSubscription'],
        Immutable.fromJS(userSubscriptionPlan)
      );

      return newState;
    }
    case FETCH_PAYMENT_METHOD_SUMMARY_SUCCESS: {
      const { userId, userSubscriptionPlanId, summary } = action;
      let newState = state;

      newState = newState.setIn(
        ['byUser', userId, 'paymentMethodSummary', userSubscriptionPlanId],
        summary
      );

      return newState;
    }
    case FETCH_OWNER_AND_ADMINS_SUCCESS: {
      const { userId, data } = action;
      let newState = state;

      data.forEach((ownerAndAdmins) => {
        newState = newState.setIn(
          ['byUser', userId, 'ownerAndAdmins', ownerAndAdmins.subscriptionId],
          ownerAndAdmins.users
        );
      });
      return newState;
    }
    case FETCH_USER_SUBSCRIPTION_PLAN_DATA_SUCCESS: {
      const { userId, loadManageSubscriptionData } = action;

      let newState = state;

      loadManageSubscriptionData.forEach(
        ({
          id,
          educatorSeats,
          billingCycleUsages,
          monthlyUsages,
          linkedCoursePaths,
          ownerAndAdmins,
          billingPeriods,
          subscriptionPlanName,
          linkedInstitutionPaths,
          linkedInstitutions,
          paymentMethodSummary,
          paymentTransactions,
          linkedInstitutionsTable,
        }) => {
          newState = newState.setIn(
            ['byUser', userId, 'monthlyUsages', id],
            monthlyUsages
          );
          newState = newState.setIn(
            ['byUser', userId, 'billingCycleUsages', id],
            billingCycleUsages
          );
          newState = newState.setIn(
            ['byUser', userId, 'ownerAndAdmins', id],
            ownerAndAdmins.users
          );
          newState = newState.setIn(
            ['byUser', userId, 'linkedCoursePaths', id],
            linkedCoursePaths.coursePaths
          );
          newState = newState.setIn(
            ['byUser', userId, 'linkedInstitutionPaths', id],
            linkedInstitutionPaths
          );
          newState = newState.setIn(
            ['byUser', userId, 'educatorSeats', id],
            educatorSeats.numEducators
          );
          newState = newState.setIn(
            ['byUser', userId, 'billingPeriods', id],
            billingPeriods
          );
          newState = newState.setIn(
            ['byUser', userId, 'planNames', id],
            subscriptionPlanName
          );
          newState = newState.setIn(
            ['byUser', userId, 'linkedInstitutions', id],
            linkedInstitutions
          );
          newState = newState.setIn(
            ['byUser', userId, 'paymentMethodSummary', id],
            paymentMethodSummary
          );
          const paymentTransactionData = {
            total: paymentTransactions.total,
            results: {
              1: paymentTransactions.results,
            },
          };
          newState = newState.setIn(
            ['byUser', userId, 'paymentTransactions', id],
            paymentTransactionData
          );
          newState = newState.setIn(
            ['byUser', userId, 'linkedInstitutionsTable', id],
            linkedInstitutionsTable
          );
        }
      );

      newState = newState.setIn(
        ['byUser', userId, 'subscriptionDataLoaded'],
        true
      );

      return newState;
    }
    case FETCH_USER_SUBSCRIPTION_PLANS_SUCCESS:
    case FETCH_COURSE_SUBSCRIPTION_DATA_SUCCESS:
    case WASABI_FETCH_USER_SUBSCRIPTIONS_SUCCESS: {
      const { userId } = action;
      const subscriptionPlans = Immutable.fromJS(action.subscriptionPlans);
      let newState = state;
      subscriptionPlans.forEach((subscriptionPlan) => {
        newState = newState.setIn(
          ['byUser', userId, 'plans', subscriptionPlan.get('id')],
          subscriptionPlan
        );
      });

      newState = newState.setIn(['byUser', userId, 'hasLoaded'], true);
      return newState;
    }
    case CANCEL_USER_SUBSCRIPTION_PLAN_SUCCESS:
    case WASABI_UPDATE_USER_SUBSCRIPTION_PLAN_EXPIRY_SUCCESS:
    case WASABI_CANCEL_USER_SUBSCRIPTION_PLAN_SUCCESS: {
      const userSubscriptionPlan = Immutable.fromJS(
        action.userSubscriptionPlan
      );
      return state.setIn(
        [
          'byUser',
          userSubscriptionPlan.get('userId'),
          'plans',
          userSubscriptionPlan.get('id'),
        ],
        userSubscriptionPlan
      );
    }
    case WASABI_SAAS_FETCH_USER_SUBSCRIPTIONS_SUCCESS: {
      const { subscriptionPlans } = action;
      let newState = state;
      Immutable.fromJS(subscriptionPlans).forEach((subscriptionPlan) => {
        newState = newState.setIn(
          ['byId', subscriptionPlan.get('id')],
          subscriptionPlan
        );
      });
      return newState;
    }
    case WASABI_SAAS_FETCH_USER_SUBSCRIPTION_PLAN_DATA_SUCCESS: {
      const { userSubscriptionPlan } = action;
      return state.setIn(
        ['byId', userSubscriptionPlan.id],
        Immutable.fromJS(userSubscriptionPlan)
      );
    }
    case LIST_INSTITUTIONS_UNDER_PLAN_SUCCESS: {
      const { institutions, userId, subscriptionId } = action;
      return state.setIn(
        ['byUser', userId, 'linkedInstitutions', subscriptionId],
        institutions
      );
    }
    default: {
      return state;
    }
  }
}
